import { useNavigate } from 'react-router-dom'
import { company, customerData } from '../../../utilities/CustomerData'

import chartLogo from '../../../assets/chartLogo.png'

export default function DashboardUpdateTranscripts({ setShowNavBar }) {
  const navigate = useNavigate()

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='w-full flex flex-col items-center gap-8'>
            <button 
              onClick={() => { setShowNavBar(false); navigate(`/chartConnect/${customerData.customerLeadData.leadContact.contactId}?isSwitch=1`) }} 
              className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-full text-3xl font-bold shadow-md'>
                <div className='flex flex-col items-center'>
                  <p className='text-2xl'>Connect Tax Transcripts</p>
                  <p className='text-lg'>Click Here</p>
                </div>
            </button>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-xl text-[#646464]'>We noticed your transcripts are currently out of date, so we'll need to update them first to ensure we can process your refund smoothly.</p>
        <div className='flex flex-row items-center gap-4'>
          <img className= 'w-14 h-14' src={chartLogo} />
          <p className='font-bold text-lg text-[#646464]'>{company.companyName} uses Chart to access your tax records.</p>
        </div>
      </div>
    </div>
  )
}